<template lang="pug">
  .flow-builder-action-find-product
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform, platform_index) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform_index", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white
        p.mb-0 Evento en Calendario
        p.text-secondary.text-sm Crea un evento en Google Calendar
        fieldset.mb-3(:disabled="disabled")
          b-form-checkbox.mb-3(
            v-if="template_attribute.name === 'from_list'",
            v-for="template_attribute in Template_Attributes",
            :key="template_attribute.template_attribute_id",
            switch,
            :checked="parseBoolean(template_attribute.value)",
            @change="updateIsFromList(template_attribute, $event)"
          ) Seleccionar por lista
          b-form-group(
            v-if="template_attribute.name === 'calendar'",
            v-for="template_attribute in Template_Attributes",
            :key="template_attribute.template_attribute_id",
            label-size="sm",
            label="Seleccionar en lista"
          )
            vue-tribute(:options="tributeOpts")
              b-form-select.disabled-white(
                v-if="isFromList",
                size="sm",
                placeholder="Selecciona credencial",
                :options="googleapis_credentials"
                :value="template_attribute.value",
                @change="updateTemplateAttribute(template_attribute, $event)"
              )
                template(#first)
                  b-form-select-option(:value="null", disabled ) -- Seleccionar cuenta --
              b-form-input.disabled-white(
                v-else
                size="sm",
                placeholder="Variable",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)"
              )
          b-link(v-b-toggle="`doc${template_id}`")
            small Documentación
            info-icon.ml-1.icon-sm
          b-collapse.my-2(:id="`doc${template_id}`")
            p.text-sm.text-secondary Más información en:
              a.ml-1(href="https://developers.google.com/calendar/api/v3/reference/events?hl=es-419#resource-representations", target="_blank") Google Events
            p.text-sm.text-secondary Ejemplo:
            ul.text-sm.text-secondary
              div
                pre
                  code {{ jsonExample }}

          b-form-group(
            v-if="template_attribute.name === 'event'",
            v-for="template_attribute in Template_Attributes",
            :key="template_attribute.template_attribute_id",
            label-size="sm",
          )
            vue-tribute(:options="tributeOpts")
              b-form-textarea.disabled-white(
                size="sm",
                no-resize,
                max-rows="100",
                placeholder="JSON",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)",
                @focusout="isJson($event)"
              )
      Connector(
        v-for="connector in Template_Connectors",
        :key="connector.template_connector_id",
        v-bind="connector",
        :block_id="block_id",
        :disabled="disabled"
      )
</template>

<script>
import templateCommon from '@/helpers/template-common'
import Connector from '@/components/templates/connectors/Connector.vue'
import TemplateTools from '@/components/templates/common/Tools.vue'
import { createNamespacedHelpers, mapActions } from 'vuex'

const templateConnectorController = createNamespacedHelpers('template_connector')
const googleapisController = createNamespacedHelpers('googleapis_credential')

export default {
  mixins: [templateCommon],
  data () {
    return {
      jsonExample: 
      `{
        'summary': 'Hello',
        'description': 'Event created from AN',
        'start': {
          'dateTime': '2024-02-16T09:00:00-07:00',
          'timeZone': 'America/Mexico_City',
        },
        'end': {
          'dateTime': '2024-02-16T17:00:00-07:00',
          'timeZone': 'America/Mexico_City',
        },
        'attendees': [
          {'email': 'lpage@example.com'},
          {'email': 'sbrin@example.com'},
        ],
        'reminders': {
          'useDefault': true
        }
      }`
    }
  },
  computed: {
    ...templateConnectorController.mapState({
      updatingConnectors: state => state.loading
    }),
    ...googleapisController.mapState({
      googleapis_credentials: state => state.googleapis_credentials.map(el => {
        return { text: el.name || el.calendar_id, value: el.googleapis_credential_id }
      })
    }),
    isFromList() {
      const from_list = this.getAttribute('from_list')
      return this.parseBoolean(from_list.value)
    }
  },
  methods: {
    ...mapActions(['googleapis_credential/all']),
    updateIsFromList(template_attribute, event) {
      this.updateTemplateAttribute(template_attribute, event)
      this.$nextTick(() => {
        const calendarSourceTemplate = this.getAttribute('calendar')
        if(calendarSourceTemplate && calendarSourceTemplate.value)
          this.updateTemplateAttribute(calendarSourceTemplate, null)
      })
    },
    updateTemplateAttribute (templateAttribute, value) {
      const attribute = JSON.parse(JSON.stringify(templateAttribute))

      if (value && value.target) {
        attribute.value = value.target._value
      } else {
        attribute.value = value
      }

      this.updateAttribute(this.block_id, this.template_id, attribute).then(() => {
        this.$message.success('Actualizado')
      })
    },
    getCredentials() {
      const self = this

      this['googleapis_credential/all']({
        account_id: this.$route.params.account_id,
        callback: res => {
          if (res.error) self.$message.error(res.error)
        }
      })
    }
  },
  components: {
    Connector,
    TemplateTools
  },
  mounted() {
    this.getCredentials()
  }
}
</script>

<style lang="scss" scoped>

  .flow-builder-action-find-product {
    position: relative;
    flex: 1 0 auto;
    max-width: 100%;
    background-color: transparent;
    white-space: normal;
  }
</style>
